// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"e1b42ba4","223":"bb3dfafa","244":"e952961f","373":"cbff37d6","376":"b436a2bb","499":"5c14269f","723":"80d0ecd4","741":"9badf470","839":"1918fc39","970":"5c2d0024"}[chunkId] + ".chunk.js";
};